import React from 'react';
import { Loading } from 'ui';
import { useTag, useAuth, } from 'api';
import { useParams, Redirect } from 'react-router-dom';
import "./index.css";

export default function TagView() {
  
  const auth = useAuth();
  const { tagId } = useParams();
  const tag = useTag(auth && auth.user.companyId, tagId);
  
  if(!tag) {
    return <Loading/>;
  }
  
  if(!tag.product) {
    return <Redirect to="product"/>;
  }
  
  if(!tag.type) {
    return <Redirect to="type"/>;
  }
  
  return <Redirect to={tag.type === "image" ? "upload" : "edit"}/>;
  
}